import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { notify } from 'libs/common';
import { Select2 } from 'libs/form';
import { GridContainer } from 'libs/ui';
import { getAdvList, getAdvListIds } from 'services/adv-service';
import { List } from './list';
import { UploadForm } from './forms/upload-form';
import { SetupBoard } from './setup-board/setup-board';
import { Content, Title, Info, Left, Right } from './adv.styled';

const defTypes = [
  { list_id: 'payment.block1', name: 'АПП Главный экран' },
  { list_id: 'payment.block2', name: 'АПП Остальные экраны' },
  { list_id: 'sidescreen', name: 'Боковой экран' },
];

export const Adv = (props) => {
  //console.log('🚀 ~ Adv ~ props:', props);
  const search = new URLSearchParams(props.location.search);
  const def = search.get('type');

  const { t } = useTranslation();

  const [types, setTypes] = useState(defTypes);
  const [type, setType] = useState(def ? def : defTypes[0].list_id);
  const [data, setData] = useState([]);
  const [refresh, setRefresh] = useState(0);
  const [typesRefresh, setTypesRefresh] = useState(0);

  /**
   * get types
   */
  useEffect(() => {
    let _mounted = true;

    const getTypes = async () => {
      let err = false;
      let isNew = true;
      const res = await getAdvListIds().catch((error) => {
        err = true;
        if (error === 'advertising.list_ids') {
          isNew = false;
        }
        if (isNew) {
          notify(t('messages.Ошибка получения списка'), error);
        }
      });
      if (err || !_mounted) {
        return;
      }
      const data = Array.isArray(res) ? res : [];
      setTypes(data);
      const cur = data.find((el) => el.list_id === type);
      if (cur) {
        setType(cur.list_id);
      } else if (data.length > 0) {
        setType(data[0].list_id);
      }
    };

    getTypes();
    return () => {
      _mounted = false;
    };
  }, [typesRefresh]);

  /**
   * get data
   */
  useEffect(() => {
    if (!type) {
      setData([]);
      return;
    }
    let _mounted = true;
    const getList = async () => {
      let err = false;
      const list = await getAdvList(type).catch((error) => {
        err = true;
        notify(t('messages.Ошибка получения списка'), error);
      });
      if (!err) {
        const out = list.items.map((el) => {
          el.id = el.item_id;
          return el;
        });
        if (_mounted) {
          setData(out);
        }
        // initial[type]
      }
    };
    getList();
    return () => {
      _mounted = false;
    };
  }, [type, refresh]);

  useEffect(() => {
    if (!type) {
      return;
    }
    props.history.push({
      //pathname: '/dresses',
      search: '?type=' + type,
    });
  }, [type]);

  /**
   * change type
   * @param {*} event
   */
  const changeType = (event) => {
    const val = event.target.value;
    setType(val);
  };

  /**
   * refresh data
   */
  const refreshData = () => {
    const newRefresh = refresh + 1;
    setRefresh(newRefresh);
  };

  // board settings of the selected type (null - no screen settings)
  const boardSettings = types.find((el) => el.list_id === type)?.board_settings || null;
  const boardRes = boardSettings?.resolution ? [boardSettings.resolution.w, boardSettings.resolution.h] : null;

  const typeItems = types.map((el) => {
    // the key is the backend name; unknown names are shown as is
    return { name: t(`adv.${el.name}`, { defaultValue: el.name }), value: el.list_id };
  });

  return (
    <GridContainer>
      <Content>
        <Info>
          <Left>
            <Title>
              <Select2 value={type} onChange={changeType} items={typeItems} />
              {boardSettings && <SetupBoard type={type} settings={boardSettings} hasFiles={data.length > 0} onSaved={() => setTypesRefresh(typesRefresh + 1)} />}
            </Title>
            {/*<Desc>Главный экран. Доступные форматы PNG, MP4 c разрешением 1024*300</Desc>*/}
          </Left>
          <Right>
            <UploadForm refreshData={refreshData} type={type} resolution={boardRes} />
          </Right>
        </Info>
      </Content>
      <List type={type} data={data} setData={setData} refreshData={refreshData} />
    </GridContainer>
  );
};
